import * as React from 'react'

import { Heading, Paragraph } from '../typography'
import { Dialog } from './dialog'
import { DialogBody } from './dialog-body'
import { DialogStateReturn } from './hooks'

interface ConfirmationDialogProps {
  state: DialogStateReturn
  title: React.ReactNode
  actions: React.ReactNode
  'aria-label': string
}

export function ConfirmationDialog(props: React.PropsWithChildren<ConfirmationDialogProps>) {
  return (
    <Dialog state={props.state} aria-label={props['aria-label']} className="w-80">
      <DialogBody>
        <Heading level={4} className="mb-2 mt-0">
          {props.title}
        </Heading>
        <Paragraph size="small">{props.children}</Paragraph>
        <div className="flex shrink-0 justify-end space-x-2 pt-4">{props.actions}</div>
      </DialogBody>
    </Dialog>
  )
}
